import './slider' // Executes the script and puts Slider on window

export function initializeCarousels(selector, container = document) {
  // Initialize global carousels array if it doesn't exist
  if (!window.carousels) {
    window.carousels = []
  }

  container.querySelectorAll(selector).forEach((carousel) => {
    // Skip if this carousel is already initialized
    if (carousel.dataset.carouselInitialized === 'true') {
      return
    }

    carousel.dataset.carouselInitialized = 'true'
    const slider = new window.Slider({
      selector: carousel,
    })

    const destroy = () => {
      slider.destroy()
      carousel.dataset.carouselInitialized = 'false'
    }
    const resizeHandler = () => {
      setTimeout(() => {
        slider.resizeHandler()
      }, 100)
    }
    window.carousels.push(slider)

    document.addEventListener('initializeCarousels', destroy)
    document.addEventListener('rerenderCarousels', resizeHandler)
  })
}
